module.exports = __webpack_public_path__ + "img/genesight_logo_tagged.f46f6397.png";